/**
 * Landing page where privacy policy is displayed
 * and QuestionnaireResponse resouce is waited before continueing
 * to actually into questionnaire
 * 
 */

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { Trans } from "react-i18next";
import i18n from  "./../../Documental/Localization/i18n.js";
import TopNav from  '../PatientApp/TopNav';
import Modal from  '../Modal/Modal';
import vestmanLogo from './vestman-01.svg';
import reaLogo from './rea.jpg';

import StateMachine from 'react-simple-state/dist';
const appState = new StateMachine();

var timerCheckResources = null;
var timerProceedPoll = null;
var resourcesLoadedRef = false;
var resourcesLoadedRefCnt = 0;
var questionnaireResponseIdGlobal = "";

function LandingPage() {
  const navigate = useNavigate();
  
  const [ privacyPolicyModalState, setPrivacyPolicyModalState ] = useState( "closed" );
  const [ resourcesLoaded, setResourcesLoaded ] = useState( false );
  const [ appMainModeLoaded, setAppMainModeLoaded ] = useState( false );
  const [ questionnaireId, setQuestionnaireId ] = useState( "" );
  const [ questionnaireResponseId, setQuestionnaireResponseId ] = useState( "" );
  const [ proceedClicked, setProceedClicked ] = useState( false );

  useEffect(() => {

    return function cleanup() {
      if ( timerProceedPoll != null) {
        //clearTimeout( timerProceedPoll );
      }
  
      if ( timerCheckResources != null) {
        clearTimeout( timerCheckResources );
      }
    };
  });
  
  /**
   * If neede resources are loaded (Questionnaire Response and Questinnaire) 
   * procceed instantly. If not - poll for them to arrive. 
   * 
   * @returns void
   */
  const handleProceedClick = () => {
    if( resourcesLoadedRef === true ){
      navigate( './../questionnaire/' + questionnaireResponseId );
      return false;
    }
    
    if ( timerProceedPoll != null) {
      clearTimeout( timerProceedPoll );
    }

    if ( timerCheckResources != null) {
      clearTimeout( timerCheckResources );
    }
    
    setProceedClicked( true );
    pollProceedClick();
  }

  const handleLogoClick = () => {
    navigate( '/' );
    return false;
  }

  const handlePrivacyPolicyClick = () => {
    setPrivacyPolicyModalState( "opened" );
    return false;
  }

  const handlePrivacyPolicyClosed = () => {
    setPrivacyPolicyModalState( "closed" );
    return false;
  }

  const pollProceedClick = () => {
    if ( timerProceedPoll != null) {
      clearTimeout( timerProceedPoll );
    }
    
    if( resourcesLoadedRef ){

      if( resourcesLoadedRefCnt > 3 ){
        navigate( './../questionnaire/' + questionnaireResponseIdGlobal );
        return;
      }
      console.log( "resourcesLoadedRefCnt : " + resourcesLoadedRefCnt + " / " + questionnaireResponseIdGlobal );
      resourcesLoadedRefCnt++;
    }
    
    timerProceedPoll = setTimeout(function () {
      pollProceedClick();
    }, 250 );
  }

  const handleDebugClick = () => {
    return false;
    console.log( "Debug" );
    console.log( window.appEntityStore.getAllResourcesBySearchParams({
      "resourceType" : "Patient"
    }) );
    
    navigate( './../rate' );
    return false;
  }

  const checkTranslationResourcesLoaded = () => {

    let trns = window.appEntityStore.getResourceById( "valueset-questions" );
      
    if( trns !== null ){
      return true;
    }

    return false;
  }


  const checkAppModeLoaded = () => {
    let currentMode = appState.getState( 'app-main-mode' );
    if( currentMode.appMainModeLoaded ){
      return true;
    }

    return false;
  }

  const checkResourcesLoaded = () => {
    
    if( resourcesLoaded ){
      if ( timerCheckResources != null) {
        clearTimeout( timerCheckResources );
      }
      return;
    }

    if( checkAppModeLoaded() ){
      // meanwhile- rerender?
      //console.log( "setAppMainModeLoaded::true" );
      //setAppMainModeLoaded( true );
    }
    
    var activityList = window.appEntityStore.getResourceById( 'fake-id-for-session-activity-list' );
    var loggedInPatient = window.appEntityStore.getAllResourcesBySearchParams({
      "resourceType" : "Patient"
    });

    // Load also translation ValueSets
    var q = null;
    var qr = null;

    if( activityList && loggedInPatient.length > 0 && checkTranslationResourcesLoaded() && checkAppModeLoaded() ){
      let res = activityList.toObject();
      let raw = res.entry[ 0 ].item.reference;
      let splitted = raw.split(  'QuestionnaireResponse/' );
      
      if( questionnaireResponseId === "" && splitted[ 1 ] ){
        questionnaireResponseIdGlobal = splitted[ 1 ];
        setQuestionnaireResponseId( splitted[ 1 ] );
      }
      
      qr = window.appEntityStore.getResourceById( splitted[ 1 ] );
      
      if( qr === null ){
        window.appEntityStore.requestResourceByReferenceUrl(
          res.entry[ 0 ].item.reference
        );
      } else {
        let questionnaireResponseJson = qr.toObject();
        let splitted2 = questionnaireResponseJson.questionnaire.split(  'Questionnaire/' );
        
        if( typeof splitted2[1] != "undefined" ){
          q = window.appEntityStore.getResourceById( splitted2[1] );
          if( q === null ){
            window.appEntityStore.requestResourceByReferenceUrl( questionnaireResponseJson.questionnaire );
          } else {
            setQuestionnaireId( splitted2[1] );
            resourcesLoadedRef = true;
            setResourcesLoaded( true );
            return;
          }
        }
      }
    }
  
    if ( timerCheckResources != null) {
      clearTimeout( timerCheckResources );
    }
  
    timerCheckResources = setTimeout(function () {
      checkResourcesLoaded();
    }, 100 );
   
  }

  checkResourcesLoaded();

  let buttonProceedClasses = "btn next mb-6";
  if( proceedClicked ){
    buttonProceedClasses = "btn loading-full mb-6";
  }

  



  let lang = i18n.language;
  let useLang = 'en';

  let introductionText = 'By answering the following questions, in 15 minutes you’ll find out if or what kind of mental health help you might need, and you’ll be able to book an appointment for a free video consultation.';
  introductionText     = 'By answering the following questions, in 15 minutes you’ll find out if or what kind of mental health help you might need, and you’ll be able to book an appointment for a video consultation.';

  let sponsorText = 'The development of the application has been supported by the Estonian sponsors National Defense Promotion Foundation and AS Vestman Energia.';
  
  if( lang === 'uk' ){
    //introductionText = "Відповівши на наступні питання, ви зможете за 15 хвилин дізнатися, чи потрібна Вам допомога для душевного здоров'я та яка, а також записатися на безкоштовну відеоконсультацію.";
    introductionText = "Надавши відповіді на наступні питання, ви зможете за 15 хвилин дізнатися, чи потрібна Вам допомога для душевного здоров'я, та яка, а також записатися на безкоштовну відеоконсультацію.";
    
    sponsorText = 'Розробку програми підтримали естонські спонсори Національний фонд сприяння обороні та AS Vestman Energia.';
    useLang = 'uk';
  }
  if( lang === 'ru' ){
    //introductionText = 'Ответив на следующие вопросы, вы сможете за 15 минут узнать, нужна ли вам помощь для душевного здоровья и какая, а также записаться на бесплатную видеоконсультацию';
    introductionText =   'Ответив на следующие вопросы, вы сможете за 15 минут узнать, нужна ли вам помощь для душевного здоровья и какая, а также записаться на видеоконсультацию со специалистом';
    
    sponsorText = 'Разработку приложения поддержали эстонские спонсоры Фонд содействия национальной обороне и AS Vestman Energia.';
    useLang = 'ru';
  }
  if( lang === 'et' ){
    //introductionText = 'Vastates järgnevatele küsimustele saate 15 minutiga teada, kas ja millist vaimse tervise alast abi te võiksite vajada ning saate broneerida aja tasuta videokonsultatsioonile. ';
    introductionText =   'Vastates järgnevatele küsimustele saate 15 minutiga teada, kas ja millist vaimse tervise alast abi te võiksite vajada ning saate broneerida aja videokonsultatsioonile. ';
    
    sponsorText = 'Rakenduse väljatöötamist on toetanud Eesti sponsorid Riigikaitse Edendamise Sihtasutus ja AS Vestman Energia.';
    useLang = 'et';
  }

  let showUaHeart = false;

  let currentMode = appState.getState( 'app-main-mode' );
  if( currentMode.appMainMode === "app-main-mode-ukrainan" ){
    showUaHeart = true;
  }
  
  return (
    <div>
      {( appMainModeLoaded ) && (
        <div></div>
      )}
      <Modal
        modalState={privacyPolicyModalState}
        onCloseClick={handlePrivacyPolicyClosed}
      >
        {( useLang === 'et' ) && (
          <div>
            {/*
            <h3 className="heading">Väike pealkiri ka siia </h3>
            <h3 className="sub-heading">Väike pealkiri ka siia </h3>
            */}
            <p>
              Enesehindamine on anonüümne. Kui hindamise tulemusena selgub, et te vajate vaimse tervise alast professionaalset abi
              ning soovite videokonsultatsiooni, siis sel hetkel palume teil sisestada teie isikuandmed.
            </p>
            <p>
              Enesehindamisel kasutatakse vaid enesehindamise tarkvara enda tööks hädavajalikke “küpsiseid” ning sisestatud 
              andmeid ei jagata kolmandate osapooltega.
            </p>
          </div>
        )}
        {( useLang === 'uk' ) && (
          <div>
          <p>
            Самооцінка анонімна. Якщо в результаті оцінки з&#39;ясується, що вам потрібна професійна
            допомога для здоров&#39;я і Ви захочете отримати відеоконсультацію, то з цього моменту, будь ласка, введіть свої особисті дані.

          </p>
          <p>
            Під час самооцінки використовуються лише «куки», які необхідні для роботи програмного забезпечення самооцінки, а введені дані не передадуть третім особам.
          </p>
          </div>
        )}
        {( useLang === 'en' ) && (
          <div>
            <p>
              Self-assessment is completely anonymous. If the assessment results show the need for professional help with 
              mental health, and you would wish for a video consultation, we will then ask you to enter your personal details. 
            </p>
            <p>
              Only &quot;cookies&quot; that are essential for the self-assessment 
              software&#39;s own use are used in the self-assessment, and the 
              entered data is not shared with third parties. 
            </p>
          </div>
        )}
        {( useLang === 'ru' ) && (
          <div>
            <p>
              Самооценка анонимна. Если в результате оценки выяснится, что вам необходима профессиональная 
              помощь для душевного здоровья, и вы захотите получить видеоконсультацию, то с этого момента, пожалуйста, введите свои личные данные. 
            </p>
            <p>
              Во время самооценки используются только «куки», которые необходимы для работы програмного обеспечения приложения самооценки, 
              а введенные вами данные не будут переданы третьим лицам.
            </p>
          </div>
        )}
      </Modal>

      <div className="app-page landing">

        <TopNav onLogoClick={handleLogoClick} />

        <div className="app-fragment pull-bottom-fixed">
          {showUaHeart && (
            <span className="icon-ua-heart mb-4" onClick={handleDebugClick}></span>
          )}
          {/*<h1>Psühholoogiline enesehindamine</h1>*/}
          <div className="content-text">
            {introductionText}
          </div>
          
          <div className="sponsor-text mb-2">
            <div>
              {sponsorText}
            </div>
          </div>
          
          <div className="sponsor-logos grid grid-cols-2 gap-4 mb-6">
            <div>
              <img src={vestmanLogo} className="vestman" />
            </div>
            <div className="">
              <img src={reaLogo} />
            </div>
          </div>
          
          <span className={buttonProceedClasses} onClick={handleProceedClick}>
            <Trans>Start</Trans>
          </span>

          <a 
            onClick={handlePrivacyPolicyClick}
            href="#/"
            className="block full-width mb-10 font-bold text-base text-white text-white-hover">
              <Trans>Privacy</Trans>
          </a>
        </div>

      </div>
    </div>
  );
}

export default LandingPage;